/** @typedef {import('../../lib/types.js').NoteContentBlock} NoteContentBlock */
import { NOTES_DEMO_CONTENT } from '../notesDemoContent'
import { meetingYouChat } from './meetingYouChat.seed'
import { meetingYouTranscript } from './meetingYouTranscript.seed'

/** @type {Record<string, NoteContentBlock[]>} */
export const meetingYouTabContent = {
  meetingDetail: [
    { type: 'heading', level: 2, text: 'Meeting detail' },
    {
      type: 'paragraph',
      text: 'Weekly standup · 45 min · Hosted by You · Mission Control squad',
    },
    { type: 'heading', level: 3, text: 'Participants' },
    {
      type: 'bullets',
      items: ['Jordan Lee', 'Sam Patel', 'Alex Rivera', 'External Client (guest)'],
    },
    { type: 'heading', level: 3, text: 'Instructions' },
    { type: 'paragraph', text: 'Standup Call — focus on shipped work, blockers, and action items.' },
  ],
  summary: [
    { type: 'heading', level: 2, text: 'Summary' },
    {
      type: 'paragraph',
      text: 'Sia generated this summary from the live transcript and your notes.',
    },
    { type: 'heading', level: 3, text: 'Key outcomes' },
    {
      type: 'bullets',
      items: [
        'Mission Control notes rail is on track for pilot',
        'Inbox briefing layout is the main dependency for next sprint',
        'Calendar integration remains out of scope until post-GA',
      ],
    },
    {
      type: 'quote',
      text: 'Team is aligned on shipping Mission Control notes before inbox v2.',
    },
  ],
  transcript: meetingYouTranscript,
  myNotes: NOTES_DEMO_CONTENT.meetingStandup,
  chat: meetingYouChat,
}
